<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'prioridadesCrud'"
          crudName="Prioridades"
          newText="Nova Prioridade"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableActive="false"
          :enableReset="false"
          :enableSenhaPath="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "prioridadesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "valor", "nome", "tempo_max_presenca_minutos", "actions"],
      tableData: ["id", "valor", "nome", "tempo_max_presenca_minutos"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "valor", "nome", "tempo_max_presenca_minutos"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          valor: "Valor",
          nome: "Nome",
          tempo_max_presenca_minutos: "Tempo Máximo de Presença (minutos)",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          setor_id: function (h, row, index) {
            return row.setor ? row.setor.nome : "Indisponível";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "prioridades/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        valor: "valor",
        nome: "nome",
        tempo_max_presenca_minutos: "tempo_max_presenca_minutos",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
